import { Avatar, Modal, MultiSelect, TextInput } from '@mantine/core';

import { ReactComponent as LeftArrowIcon } from 'assets/icons/orangeLeftArrow.svg';
import { ReactComponent as DownArrowIcon } from 'assets/icons/downArrow2.svg';

import PrimaryButton from 'components/primaryButton';
import { Controller, useForm } from 'react-hook-form';

import useGetEmployeeList from '../../hooks/useGetEmployeeList';
import useAddNewFolder from '../../hooks/useAddNewFolder';
import useGetFolders from '../../hooks/useGetFolders';
import useUpdateFolder from '../../hooks/useUpdateFolder';
import useAddNewEmpolyeeFolder from '../../hooks/useAddnewEmployee';
import useDeleteEmployeeFromFolder from '../../hooks/useDeleteEmployeeFromFolder';
import { useEffect, useState } from 'react';

const AddNewFolderModal = ({
  newFolderModal,
  setNewFolderModal,
  folderId,
  setFolderId,
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    watch,
    reset,
    setValue,
  } = useForm({ mode: 'onchange' });

  useEffect(() => {
    if (!folderId) {
      reset({});
    }
    // eslint-disable-next-line
  }, [newFolderModal]);

  const defaultValues = {
    name: '',
    members: '',
  };

  const closeModal = () => {
    setNewFolderModal(false);
    setFolderId(null);
    reset({ defaultValues });
  };

  const customTitle = () => {
    return (
      <div className='relative flex justify-center items-center text-xl mx-4 my-4'>
        <LeftArrowIcon
          onClick={() => {
            setNewFolderModal(false);
            closeModal();
          }}
          className='w-4 absolute left-0 cursor-pointer'
        />
        <p>{folderId ? 'Update folder' : 'Create folder'}</p>
      </div>
    );
  };

  const getErrorMessage = (name) => {
    return (
      errors[name] && (
        <p className=' text-sm font-semibold text-red-500'>
          {errors[name]?.message}
        </p>
      )
    );
  };

  const employeeList = useGetEmployeeList();
  const addNewFolderMutation = useAddNewFolder(closeModal);
  const updateFoldermutation = useUpdateFolder(closeModal);
  const getFolderData = useGetFolders(folderId);
  const addNewEmployee = useAddNewEmpolyeeFolder();
  const removeEmployee = useDeleteEmployeeFromFolder();

  const AddNewFolder = (data) => {
    if (folderId) {
      updateFoldermutation.mutate({ name: data?.name, id: folderId });
    } else {
      addNewFolderMutation.mutate(data);
    }
  };

  // function getDifference(array1, array2) {
  //   if (array1?.length !== 0 && array2?.length !== 0) {
  //     return array1?.filter((object1) => {
  //       return array2?.some((object2) => {
  //         return object1?.id === object2;
  //       });
  //     });
  //   }
  // }

  // const showprofilesData = getDifference(
  //   employeeList?.data?.data,
  //   watch('members')
  // );

  useEffect(() => {
    if (folderId && getFolderData?.data?.data) {
      const checkValue = getFolderData?.data?.data[0]?.members?.map(
        (item) => `${item?.employee__id}`
      );
      setValue('name', getFolderData?.data?.data[0]?.name);
      setValue('members', checkValue);
      setTeamMembers(
        getFolderData?.data?.data[0]?.members?.map((eachMember) => {
          return eachMember.employee__id;
        })
      );
    }
    // eslint-disable-next-line
  }, [getFolderData?.data?.data, getFolderData?.isSuccess]);

  const [teamMembers, setTeamMembers] = useState([]);

  const changeHandler = (data) => {
    if (folderId) {
      if (data?.length > teamMembers?.length) {
        addNewEmployee.mutate({
          folder_id: folderId,
          employee_id: data[data?.length - 1],
        });
        setValue('members', data);
        setTeamMembers(data);
      }

      if (data?.length < teamMembers?.length) {
        const teamData = teamMembers?.map((each) => {
          return parseInt(each);
        });
        const d1 = data?.map((each) => {
          return parseInt(each);
        });
        const removedEmployee = teamData?.filter(
          (member) => d1.indexOf(member) === -1
        );

        const obj = getFolderData?.data?.data[0]?.members?.find(
          (o) => o?.employee__id === removedEmployee[0]
        );
        removeEmployee.mutate({
          id: obj?.id,
        });

        removeEmployee?.isSuccess && setValue('members', data);
        removeEmployee?.isSuccess && setTeamMembers(data);
      }
    } else {
      setValue('members', data);
    }
  };

  const getDropdownData = () => {
    const dataArray = [];
    employeeList?.data?.data?.map((employee) => {
      if (~~watch('lead_id') !== employee.id) {
        dataArray.push({
          image: employee?.profile_picture,
          label: employee.user__first_name,
          value: `${employee.id}`,
          description: employee?.designation__name,
          activeStatus: employee?.user__is_active,
          disabled: employee?.user__is_active ? false : true,
        });
      }
      return true;
    });
    return dataArray;
  };

  //   custom dropdown item for select
  const SelectItem = ({
    activeStatus,
    value,
    label,
    image,
    name,
    description,
    ...others
  }) => {
    return (
      <div className='flex px-5 '>
        <div
          {...others}
          className={`flex items-center py-2 cursor-pointer  ${
            activeStatus ? '' : 'opacity-60'
          } `}
        >
          <Avatar src={image} color='red'>
            {label[0]?.toUpperCase()}
          </Avatar>
          <div className='pl-1 '>
            <p className='text-18 '>{label} </p>
            <p className='text-xs text-gray3 pt-1 '>{description} </p>
          </div>
        </div>
        <p className='ml-auto'>
          {' '}
          {activeStatus ? (
            <span className='ml-3 text-[12px] text-[#28B446] bg-[#c1f3cc] py-1 px-2 rounded-lg '>
              Active
            </span>
          ) : (
            <span className='ml-3 text-[12px] text-[#D0342C] bg-[#f7bab6] py-1 px-2 rounded-lg'>
              Inactive
            </span>
          )}
        </p>
      </div>
    );
  };

  return (
    <Modal
      opened={newFolderModal}
      onClose={() => {
        setNewFolderModal(false);
      }}
      title={customTitle()}
      withCloseButton={false}
      overlayColor={'#F8F7F799'}
      overlayBlur={20}
      overlayOpacity={0.5}
      centered
      size={600}
      radius='md'
      overflow='inside'
      transitionDuration={100}
      classNames={{
        title: 'w-full  font-semibold text-18',
        modal: 'pl-10',
        body: 'scroller -mr-4 pr-2',
      }}
    >
      <form className='px-4' onSubmit={handleSubmit(AddNewFolder)}>
        <div>
          <Controller
            control={control}
            name='name'
            rules={{
              required: 'Required',
              /* 
              This validation is commented as per the issue AG-537
              
              pattern: {
                value: /^[ A-Za-z0-9_@.#&+(-)]*$/,
                message: 'Input must be an alphabets or integers',
              }, */
            }}
            render={({ field }) => (
              <TextInput
                {...field}
                label='Name of the folder'
                size='md'
                classNames={{
                  input: 'border-primary',
                  label: 'text-neutralsGrey text-sm',
                }}
              />
            )}
          />
          {getErrorMessage('name')}
        </div>

        {folderId ? (
          <div className='py-4'>
            <Controller
              control={control}
              name='members'
              // rules={{ required: 'required' }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  size='md'
                  itemComponent={SelectItem}
                  label='Add team members'
                  placeholder='Search or select'
                  searchable
                  onChange={(data) => changeHandler(data)}
                  data={
                    !employeeList?.data?.data?.length ? [] : getDropdownData()
                  }
                  rightSection={<DownArrowIcon />}
                  styles={{ rightSection: { pointerEvents: 'none' } }}
                  classNames={{
                    input: 'border-primary',
                    label: 'text-neutralsGrey text-sm',
                  }}
                />
              )}
            />
            {getErrorMessage('members')}
          </div>
        ) : (
          <div className='w-full py-2'>
            <Controller
              control={control}
              name='members'
              // rules={{ required: 'required' }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  size='md'
                  itemComponent={SelectItem}
                  label='Add team members'
                  placeholder='Search or select'
                  searchable
                  data={
                    !employeeList?.data?.data?.length ? [] : getDropdownData()
                  }
                  rightSection={<DownArrowIcon />}
                  styles={{ rightSection: { pointerEvents: 'none' } }}
                  classNames={{
                    input: 'border-primary',
                    label: 'text-neutralsGrey text-sm',
                  }}
                />
              )}
            />
            {getErrorMessage('members')}
          </div>
        )}

        {/* <div className='flex items-center gap-2'>
          {showprofilesData?.map((eachprofile) => {
            return (
              <Tooltip
                label={
                  <div>
                    <p className='text-gray'>
                      Name: {eachprofile?.user__first_name}
                    </p>
                    <p className='text-gray'>
                      Department: {eachprofile?.department__name}
                    </p>
                  </div>
                }
                wrapLines
                classNames={{
                  body: 'bg-white text-gray2 shadow-tooltip pr-3 z-0',
                }}
                radius='md'
              >
                <Avatar
                  src={eachprofile?.profile_picture}
                  radius='lg'
                  color='#FB7C51'
                  className='w-10 h-10'
                >
                  {eachprofile?.user__first_name?.substring(0, 1)}
                </Avatar>
              </Tooltip>
            );
          })} 
        </div>*/}
        <div className='flex justify-center items-center my-4'>
          <button>
            <PrimaryButton>Save</PrimaryButton>
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddNewFolderModal;
